import {
  setUserList,
  setTagsInUsers,
  setUser,
  setCurrentUser,
  setAirports,
  selUserId,
  setCountriesInUser,
} from "./userSlice";

// import * as R from "ramda";
import loaderClient from "api/reduxLoaderApi";
import * as R from "ramda";

import { remUserData, remUserDataCreate } from "./models/userModels";
import {
  setPendUserList,
  setPendUser,
  selPendUserList,
  selPendUserTableFilters,
} from "../../users-management/slice/userSlice";
import { selAirlineId } from "store/slices";

export const getAllUsers = () => async (dispatch) => {
  const client = loaderClient("get")("/users?limit=1000");
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setUserList(res.message));
};

export const getUserById = (id) => async (dispatch) => {
  const client = loaderClient("get")(`/users/${id}`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setUser({ ...res.message }));
};

export const getPendUserList = () => async (dispatch, getState) => {
  const airlineId = selAirlineId(getState());
  let filters = selPendUserTableFilters(getState());
  let params = `airline=${airlineId}&status=pending`;
  if (filters?.page) params += `&page=${filters.page}`;
  if (filters?.limit) params += `&limit=${filters.limit}`;
  const client = loaderClient("get")(`/join-requests?${params}`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(
    setPendUserList({
      users: res.message,
      totalItems: res.result_number,
    })
  );
  // return dispatch(setUserList(res.message));
};

export const getPendUser = (userId) => async (dispatch) => {
  const client = loaderClient("get")(`/join-requests/${userId}`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setPendUser(res.message));
};

// export const getUserById = (id) => async (dispatch) => {
//   const client = loaderClient("get")(`/users/${id}`);
//   const res = await client({})({});
//   if (!res.message) return "";
//   return dispatch(setUser({ ...res.message.user, password: "******" }));
// };

export const getAllTags = () => async (dispatch) => {
  const client = loaderClient("get")("/tags?limit=all");
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setTagsInUsers(res.message));
};

export const addGroupToUser = (data) => async (dispatch) => {
  // console.log(data);
  const { user } = data;
  const client = loaderClient("post")(`/users/${user}/assignments/`);
  const res = await client(data)({});
  if (!res.message) return "";
  return dispatch(getCurrentUserAssignments(data.user));
};
export const RemoveGroupFromUser = (user, id) => async (dispatch) => {
  // console.log(data);
  const client = loaderClient("delete")(`/users/${user}/assignments/${id}`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(getCurrentUserAssignments(user));
};

export const addTagsToUser = (user, tagsData) => async (dispatch) => {
  const client = loaderClient("patch")(`/users/${user.id}`);
  const res = await client(tagsData)({});
  if (!res.message) return "";
  return dispatch(getAllUsers());
};

export const createUser =
  (data, callback = false) =>
  async (dispatch) => {
    const client = loaderClient("post")(`/users`);
    const validData = remUserDataCreate(data);
    const res = await client(validData)({});
    return callback(res.error, res.message);
    // if (!res.message) return "";
    // return dispatch(getAllUsers());
  };

export const editUser =
  (data, callback = false) =>
  async (dispatch, getState) => {
    const id = selUserId(getState());
    const noPaass = R.omit(["password"])(data);
    const client = loaderClient("patch")(`/users/${id}`);
    const res = await client(remUserData(noPaass))({});
    if (!res.error) getUserById(id);
    return callback && callback(res.error, res.message);
    // return dispatch(getAllUsers());
  };

export const getCurrentUserAssignments = (id) => async (dispatch) => {
  const client = loaderClient("get")(`/users/${id}`);
  const res = await client({})({});
  if (!res.message) return "";

  return dispatch(setCurrentUser(res.message));
};

export const searchAirports = (searchItem) => async (dispatch) => {
  const client = loaderClient("get")(`/airports?${searchItem}`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setAirports(res.message));
};

export const getAllCountries = () => async (dispatch) => {
  const client = loaderClient("get")("/countries");
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setCountriesInUser(res.message));
};

// export const createTag = (data, callback) => async (dispatch) => {
//   const client = loaderClient("post")("/tags");
//   const res = await client(data)({});
//   if (!res.message) return "";
//   return dispatch(getAllUsers());
// };
